import React from "react"
import { STATUS } from "./utils/constants/statuses"
import { resolveUrlForArticles, careerPathToSlug } from "./utils/urlUtils"
import { interpolate, getCurrentUnixTimestamp } from "./utils/displayUtils"
import {
  getCurriculumCode,
  buildCanvasUrlForRequirement,
  CANVAS_URLS,
} from "./utils/constants/externalUrls"
import { useMembershipJourneyContext } from "./MembershipJourneyContext"
import {
  RequirementActions,
  ActionButton,
  ActionButtonText,
  TextButton,
} from "./Styles/ProgressTracker.styles"

const RequirementActionLinks = ({
  displayData,
  requirementStatus,
  activeLevel,
  requirementKey,
}) => {
  const { pgaId, pgmProgress } = useMembershipJourneyContext()
  const careerPath = pgmProgress?.careerPath
  const curriculumVersion = pgmProgress?.curriculumVersion || "3.1"

  if (!displayData) {
    return null
  }

  const hasPrimaryLink =
    displayData.primaryLinkText && displayData.primaryLinkUrl
  const hasSecondaryLink =
    displayData.secondaryLinkText && displayData.secondaryLinkUrl
  const hasActionLink = hasPrimaryLink || hasSecondaryLink
  const isActionable = requirementStatus !== STATUS.LOCKED

  if (!hasActionLink || !isActionable) {
    return null
  }

  const unixTimestamp = getCurrentUnixTimestamp()

  const slug = careerPathToSlug(careerPath)
  const careerPathSlug = slug ? `${slug}-` : ""
  const curriculumCode = getCurriculumCode(curriculumVersion)

  const activeLevelData = pgmProgress?.levels?.find(
    level => level.key === activeLevel,
  )
  const levelCode = activeLevelData?.levelCode

  const canvasUrl =
    levelCode && requirementKey
      ? buildCanvasUrlForRequirement(activeLevel, levelCode, requirementKey)
      : null

  const interpolationContext = {
    pgaId,
    unixTimestamp,
    careerPathSlug,
    curriculumCode,
    canvasUrl: canvasUrl || CANVAS_URLS.HOME,
  }

  const primaryUrl = resolveUrlForArticles(
    interpolate(displayData.primaryLinkUrl, interpolationContext),
  )
  const secondaryUrl = resolveUrlForArticles(
    interpolate(displayData.secondaryLinkUrl, interpolationContext),
  )

  return (
    <RequirementActions>
      {hasPrimaryLink && (
        <ActionButton
          as="a"
          href={primaryUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <ActionButtonText>{displayData.primaryLinkText}</ActionButtonText>
        </ActionButton>
      )}
      {hasSecondaryLink && (
        <TextButton
          as="a"
          href={secondaryUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          {displayData.secondaryLinkText}
        </TextButton>
      )}
    </RequirementActions>
  )
}

export default RequirementActionLinks
